import api from '../../api';

const state = {
  order: null,
  error: null,
  isLoading: true,
  isSubmitting: false,
  memorialInfo: null,
  submitted: false,
  guestLink: '',
};

const mutations = {
  setOrder(state, data) {
    state.order = data;
  },

  setIsLoading(state, isLoading = true) {
    state.isLoading = isLoading;
  },

  setIsSubmitting(state, isSubmitting = true) {
    state.isSubmitting = isSubmitting;
  },

  setSubmitted(state, submitted = null) {
    state.submitted = submitted;
  },

  setGuestLink(state, guestLink = '') {
    state.guestLink = guestLink;
  },

  setError(state, error = null) {
    state.error = error;
  },
};

const actions = {
  getOrder(context, id) {
    context.commit('setIsLoading');

    fetch(`${lavendlaObituary.backendAPIUrl}/external-orders/${id}`)
      .then((response) => response.json())
      .then(({ data }) => {
        context.commit('setOrder', data);
        context.commit('setIsLoading', false);
      })
      .catch((error) => {
        context.commit('setIsLoading', false);
        context.commit('setError', error);
      });
  },

  rsvp(context, data) {
    context.commit('setIsSubmitting');
    api
      .post('rsvp', data)
      .then((data) => {
        context.commit('setGuestLink', data?.guestLink || '');
        context.commit('setSubmitted', true);
        context.commit('setIsSubmitting', false);
      })
      .catch((error) => {
        context.commit('setError', error);
        context.commit('setIsSubmitting', false);
      });
  },
};

export default {
  state,
  mutations,
  actions,
  namespaced: true,
};
